$(document).ready(function () {
  // click outside popups
  $(window).click(function (evt) {
    $("#login-modal").css("display", "none");
    $("#login-modal-reg").css("display", "none");
    $("#oops-modal").css("display", "none");
    $("#calendar-modal").css("display", "none");

    if (
      !$("#filterModal").is(evt.target) &&
      $("#filterModal").has(evt.target).length === 0
    ) {
      $(".popup-overlay").remove();
      $("#filterModal").css("display", "none");
    }

    $(".gift-text").css("display", "none");
    $(".top-socials-wrapper").css("display", "none");

    $(".panel").removeClass("open");

    $(".search__results-desktop").hide();
    $(".forecast-table-tooltip").css("display", "none");
    $(".forecast-table-tooltip-bet-value").css("display", "none");
    $("#prognosticModal").css("display", "none");
  });

  $(
    ".modal__dialog, .gift-text, .top-socials-wrapper, .panel, .header__search-wrap, .forecast-table-tooltip, .forecast-table-tooltip-bet-value, .prognostic__modal-container, .search__results-desktop"
  ).click(function (event) {
    event.stopPropagation();
  });

  $(".open-login").click(function () {
    $("#login-modal-reg").css("display", "none");

    if ($(".popup-overlay").length == 0)
      $("body").append('<div class="popup-overlay"></div>');

    $("#login-modal").toggle("fast");
    return false;
  });

  $(".info .open-oops").on("click", function () {
    if ($(".popup-overlay").length == 0)
      $("body").append('<div class="popup-overlay"></div>');

    $("#oops-modal").toggle("fast");
    return false;
  });

  $(".bk-intro .open-oops").on("click", function () {
    if ($(".popup-overlay").length == 0)
      $("body").append('<div class="popup-overlay"></div>');

    $("#oops-modal").toggle("fast");
    return false;
  });

  $(".bonus .open-oops").on("click", function () {
    if ($(".popup-overlay").length == 0)
      $("body").append('<div class="popup-overlay"></div>');

    $("#oops-modal").toggle("fast");
    return false;
  });

  $(".rating__table").on("click", ".open-oops", function () {
    if ($(".popup-overlay").length == 0)
      $("body").append('<div class="popup-overlay"></div>');

    $("#oops-modal").toggle("fast");
    return false;
  });

  $(".header__bk .open-oops").on("click", function () {
    if ($(".popup-overlay").length == 0)
      $("body").append('<div class="popup-overlay"></div>');

    $("#oops-modal").toggle("fast");
    return false;
  });

  $("#oops-modal .modal__close").click(function () {
    $("#oops-modal").css("display", "none");
    $(".popup-overlay").remove();
    return false;
  });
});
